import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import { useNavHover } from "../../../utils/Actions/navHover";
import { useHoverBackground } from "../../../utils/Actions/useHoverBackground";
import colors from "../../../data/colors";
import { S3URL } from "../../../data/globalConstants";

export default function HomePanel({ item, panelIndex }) {
  const navHover = useNavHover();
  const hoverProps = useHoverBackground(
    colors[panelIndex].dark.hex,
    colors[panelIndex].light.hex,
  );

  const featured = useMemo(() => {
    // console.log(item);
    const shows = Array.isArray(item?.shows) ? item.shows : [];

    // Prefer entries that have a bg video (and thumbnail if present)
    const candidates = shows.filter((s) => s?.bg_video);
    const pool = candidates.length ? candidates : shows;

    if (!pool.length) return null;

    const idx = Math.floor(Math.random() * pool.length);

    return pool[idx];
  }, [item?.shows]);

  const bgVideoSrc = featured?.bg_video || "";
  const bgPosterSrc = featured?.bgv_thumbnail || "";
  const featuredTitle = featured?.title || "";
  const featuredSlug = featured?.slug || "";

  return (
    <section
      id={item.slug}
      className="panel"
      aria-labelledby={`${item.slug}-heading`}
    >
      <div className="video-container">
        {bgVideoSrc && (
          <video
            key={bgVideoSrc}
            className={navHover ? "blur-more" : ""}
            poster={S3URL + bgPosterSrc || undefined}
            loop
            muted
            playsInline
            controls={false}
            aria-hidden="true"
            preload="auto"
          >
            {bgVideoSrc ? <source src={S3URL + bgVideoSrc} /> : null}
            Your browser does not support the video tag.
          </video>
        )}
        {!bgVideoSrc && (
          <img
            src={S3URL + featured?.bg_image || undefined}
            alt="Netflix"
            className={"panel-background-placeholder"}
          />
        )}
      </div>

      <div className={`info-container ${navHover ? "blur-less" : ""}`}>
        <div className="info-meta">
          <div className="title-genre">{item.title}</div>
          <div className="title-name">{featuredTitle}</div>
        </div>
        <div className="info-btn">
          <Link
            to={"/" + item.slug + "/" + featuredSlug}
            className="title-button"
            aria-label={`Explore ${featuredTitle}`}
            {...hoverProps}
          >
            <span>Explore</span>
          </Link>
        </div>
      </div>
      <div className="panel-gradient panel-gradient-bw" aria-hidden="true" />
      <div
        className="panel-gradient panel-gradient-color"
        aria-hidden="true"
        style={{
          background: `linear-gradient(90deg, rgba(${colors[panelIndex].dark.rgb},1) 0%, rgba(${colors[panelIndex].dark.rgb},0) 100%)`,
        }}
      />
    </section>
  );
}
